<template>
  <div v-loading="loading" class="page-wrap">
    <el-row>
      <el-col :xs="24" :sm="20" :lg="12" :xl="14">
        <el-form
          label-position="top"
          size="large"
          :model="form"
          :rules="rules"
          ref="formRef"
        >
          <el-row>
            <el-col :xs="24" :sm="18" :lg="16" :xl="14">
              <el-form-item label="Tashabbuslar doskasi" prop="board">
                <el-select
                  v-model="form.board"
                  style="width: 100%"
                  placeholder="Doskani tanlang"
                >
                  <el-option
                    v-for="board in boards"
                    :key="board.id"
                    :value="board.id"
                    :label="
                      board.title +
                      ' ' +
                      board.season +
                      '-' +
                      'mavsum ' +
                      board.year +
                      ' yil'
                    "
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="18" :lg="16" :xl="14">
              <el-button type="primary" @click="downloadFile"
                ><img
                  src="@/assets/images/icons/download.svg"
                  alt=""
                  style="margin-right: 5px"
                />
                Faylni yuklab oling
              </el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { ElNotification } from "element-plus";

export default {
  name: "Reestor",
  data() {
    return {
      loading: false,
      boards: [],
      form: {
        board: null,
        file: [],
      },
      rules: {
        board: [
          { required: true, message: "Majburiy maydon!", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    getBoardList() {
      this.$http
        .get("api/v1/boards",{params:{status:1}})
        .then(({ data }) => {
          this.boards = data.boards;
        })
        .catch(() => {});
    },
    downloadFile() {
      this.$refs.formRef.validate((valid, fields) => {
        if (valid) {
          this.loading = true;
          this.$http
            .get(`api/v1/initiatives-excel-products`, {
              responseType: "blob",
              params: {
                board_id: this.form.board,
              },
            })
            .then((res) => {
              const url = URL.createObjectURL(
                new Blob([res.data], {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
                })
              );
              const header = res.headers.get("Content-Disposition");
              const parts = header.split(";");
              let fileName = parts[1].split("=")[1];
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", fileName);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            })
            .catch(({ response }) => {
              ElNotification({
                title: "Ogohlantirish",
                message:
                  response.data.message ||
                  "Ma'lumot yuklashda xatolik sodir bo'ldi!",
                type: "warning",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
  },

  mounted() {
    this.getBoardList();
  },
};
</script>

<style scoped>
.page-wrap {
  padding: 20px;
}

.upload-demo {
  width: 100%;
}
</style>
